/**
 * MR JERRY CLUB — Promocje / Opinie / Pomysły (3 ekrany member).
 * Lean: jeden plik, 3 named exports.
 */
import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { clubApi, formatApiErrorDetail } from './clubApi';

const fmt = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('pl-PL', { day: '2-digit', month: 'short' }); }
  catch { return iso; }
};

// ======================== PROMOTIONS ========================
const PROMO_ICON = { drink: '🍹', food: '🍕', event: '🎉', hours: '⏰', general: '🎁' };

export function ClubPromotions() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    clubApi.get('/promotions').then((r) => setItems(r.data.promotions || [])).catch(() => setItems([]));
  }, []);

  return (
    <div className="club-shell">
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>🎁 Promocje</div>
        <div style={{ fontSize: 12, color: 'var(--club-text-muted)' }}>To co dzieje się w MR JERRY</div>
      </div>

      {items === null ? <div className="club-loading"><div className="club-loading-spinner" /></div>
        : items.length === 0 ? (
          <div className="club-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 36, marginBottom: 8 }}>📭</div>
            <div style={{ fontSize: 14 }}>Brak aktualnych promocji. Wróć za chwilę!</div>
          </div>
        ) : items.map((p) => (
          <div key={p.id} className="club-card" style={{ padding: 0, overflow: 'hidden' }} data-testid={`club-promo-${p.id}`}>
            <div style={{
              height: 140,
              background: p.photo ? `url(${p.photo}) center/cover`
                : 'linear-gradient(135deg, rgba(212,175,55,0.20), rgba(212,175,55,0.05))',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 60,
            }}>{!p.photo && (PROMO_ICON[p.type] || '🎁')}</div>
            <div style={{ padding: 16 }}>
              <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--club-gold)' }}>{p.name}</div>
              <div style={{ fontSize: 13, color: 'var(--club-text)', marginTop: 6, lineHeight: 1.5 }}>{p.description}</div>
              {(p.valid_from || p.valid_to) && (
                <div style={{ fontSize: 11, color: 'var(--club-text-muted)', marginTop: 8 }}>
                  ⏱️ {p.valid_from ? fmt(p.valid_from) : ''}{p.valid_from && p.valid_to ? ' – ' : ''}{p.valid_to ? fmt(p.valid_to) : ''}
                </div>
              )}
              {p.terms && (
                <div style={{ fontSize: 11, color: 'var(--club-text-muted)', marginTop: 4, fontStyle: 'italic' }}>
                  * {p.terms}
                </div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
}

// ======================== REVIEW FORM ========================
export function ClubReviewForm() {
  const [rating, setRating] = useState(0);
  const [liked, setLiked] = useState('');
  const [improve, setImprove] = useState('');
  const [rec, setRec] = useState('');
  const [location, setLocation] = useState('nowysacz');
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!rating) { toast.error('Wybierz ocenę 1-5 ⭐'); return; }
    if (!rec) { toast.error('Wybierz czy nas polecisz'); return; }
    setBusy(true);
    try {
      await clubApi.post('/reviews', { rating, q_liked: liked, q_improve: improve, q_recommend: rec, location });
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  if (submitted) return (
    <div className="club-shell">
      <div className="club-brand">
        <div className="club-brand-logo" style={{ background: 'linear-gradient(135deg, #10b981, #047857)' }}>🙏</div>
        <h1 className="club-brand-name" style={{ color: '#10b981' }}>Dziękujemy!</h1>
        <div className="club-brand-sub">Każde słowo nam pomaga</div>
      </div>
      <div className="club-card gold">
        Opinia trafiła do managera. Jeśli okaże się wyjątkowo wartościowa — możesz dostać bonus punktowy!
      </div>
    </div>
  );

  return (
    <div className="club-shell">
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>⭐ Oceń wizytę</div>
        <div style={{ fontSize: 12, color: 'var(--club-text-muted)' }}>Pomóż nam być lepszym</div>
      </div>
      <form onSubmit={submit} data-testid="club-review-form">
        <label className="club-label">Ogólna ocena</label>
        <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" onClick={() => setRating(n)} data-testid={`club-review-star-${n}`}
              style={{
                flex: 1, padding: 12, borderRadius: 10, fontSize: 26,
                border: rating === n ? '2px solid var(--club-gold)' : '1px solid var(--club-border-soft)',
                background: rating === n ? 'rgba(212,175,55,0.10)' : 'transparent',
                color: rating >= n ? 'var(--club-gold)' : 'var(--club-text-muted)',
                cursor: 'pointer', fontFamily: 'inherit',
              }}>★</button>
          ))}
        </div>

        <label className="club-label">Lokal</label>
        <select className="club-input" value={location} onChange={(e) => setLocation(e.target.value)} data-testid="club-review-location">
          <option value="nowysacz">🏔️ Nowy Sącz</option>
          <option value="krakow">🏰 Kraków</option>
          <option value="grodek">🌊 Gródek nad Dunajcem</option>
        </select>
        <div style={{ height: 12 }} />

        <label className="club-label">Co najbardziej Ci się podobało?</label>
        <textarea className="club-input" rows={3} value={liked} onChange={(e) => setLiked(e.target.value)}
          placeholder="np. obsługa, atmosfera, jedzenie…" maxLength={1000}
          data-testid="club-review-liked" />
        <div style={{ height: 12 }} />

        <label className="club-label">Co możemy poprawić?</label>
        <textarea className="club-input" rows={3} value={improve} onChange={(e) => setImprove(e.target.value)}
          placeholder="Twoje uwagi, sugestie…" maxLength={1000}
          data-testid="club-review-improve" />
        <div style={{ height: 12 }} />

        <label className="club-label">Polecisz nas znajomym?</label>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6, marginBottom: 18 }}>
          {[
            { v: 'yes', l: '👍 Tak' },
            { v: 'maybe', l: '🤔 Może' },
            { v: 'no', l: '👎 Nie' },
          ].map((o) => (
            <button key={o.v} type="button" onClick={() => setRec(o.v)} data-testid={`club-review-rec-${o.v}`}
              style={{
                padding: 12, borderRadius: 10, fontFamily: 'inherit',
                background: rec === o.v ? 'rgba(212,175,55,0.10)' : 'rgba(0,0,0,0.3)',
                border: `1px solid ${rec === o.v ? 'var(--club-gold)' : 'var(--club-border-soft)'}`,
                color: rec === o.v ? 'var(--club-gold)' : 'var(--club-text)',
                fontSize: 12, fontWeight: 700, cursor: 'pointer',
              }}>{o.l}</button>
          ))}
        </div>

        <button type="submit" className="club-btn club-btn-primary" disabled={busy || !rating} data-testid="club-review-submit">
          {busy ? 'Wysyłanie…' : '⭐ Wyślij opinię'}
        </button>
      </form>
    </div>
  );
}

// ======================== IDEA FORM ========================
const IDEA_CATS = [
  { id: 'food', icon: '🍕', label: 'Jedzenie' },
  { id: 'desserts', icon: '🍰', label: 'Desery' },
  { id: 'drinks', icon: '🍹', label: 'Drinki' },
  { id: 'events', icon: '🎉', label: 'Wydarzenia' },
  { id: 'promotions', icon: '🎁', label: 'Promocje' },
  { id: 'service', icon: '🤝', label: 'Obsługa' },
  { id: 'decor', icon: '🪑', label: 'Wystrój' },
  { id: 'other', icon: '💭', label: 'Inne' },
];

export function ClubIdeaForm() {
  const [category, setCategory] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!category) { toast.error('Wybierz kategorię'); return; }
    if (!title.trim()) { toast.error('Wpisz krótki tytuł'); return; }
    if (!description.trim()) { toast.error('Opisz pomysł'); return; }
    setBusy(true);
    try {
      await clubApi.post('/ideas', { category, title: title.trim(), description: description.trim() });
      setSubmitted(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  if (submitted) return (
    <div className="club-shell">
      <div className="club-brand">
        <div className="club-brand-logo" style={{ background: 'linear-gradient(135deg, #6366f1, #4338ca)' }}>💡</div>
        <h1 className="club-brand-name" style={{ color: '#6366f1' }}>Dostaliśmy!</h1>
        <div className="club-brand-sub">Wkrótce sprawdzimy</div>
      </div>
      <div className="club-card gold">
        Pomysł trafił na biurko managera. Jeśli go wdrożymy lub wyróżnimy — dostaniesz punkty bonusowe!
      </div>
    </div>
  );

  return (
    <div className="club-shell">
      <div style={{ marginBottom: 18 }}>
        <div style={{ fontSize: 22, fontWeight: 800 }}>💡 Twój pomysł</div>
        <div style={{ fontSize: 12, color: 'var(--club-text-muted)' }}>Pomóż nam rozwijać MR JERRY</div>
      </div>
      <form onSubmit={submit} data-testid="club-idea-form">
        <label className="club-label">Kategoria</label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6, marginBottom: 16 }}>
          {IDEA_CATS.map((c) => (
            <button key={c.id} type="button" onClick={() => setCategory(c.id)} data-testid={`club-idea-cat-${c.id}`}
              style={{
                padding: 10, borderRadius: 10, fontFamily: 'inherit',
                background: category === c.id ? 'rgba(212,175,55,0.15)' : 'rgba(0,0,0,0.3)',
                border: `1px solid ${category === c.id ? 'var(--club-gold)' : 'var(--club-border-soft)'}`,
                color: category === c.id ? 'var(--club-gold)' : 'var(--club-text)',
                fontSize: 10, fontWeight: 700, cursor: 'pointer', textAlign: 'center',
              }}>
              <div style={{ fontSize: 22 }}>{c.icon}</div>
              <div style={{ marginTop: 4 }}>{c.label}</div>
            </button>
          ))}
        </div>

        <label className="club-label">Krótki tytuł</label>
        <input className="club-input" value={title} onChange={(e) => setTitle(e.target.value)}
          placeholder="np. Nowy koktajl z mango" maxLength={200}
          data-testid="club-idea-title" />
        <div style={{ height: 12 }} />

        <label className="club-label">Opis</label>
        <textarea className="club-input" rows={5} value={description} onChange={(e) => setDescription(e.target.value)}
          placeholder="Opowiedz nam więcej…" maxLength={2000}
          data-testid="club-idea-description" />
        <div className="club-help" style={{ textAlign: 'right' }}>{description.length} / 2000</div>
        <div style={{ height: 12 }} />

        <button type="submit" className="club-btn club-btn-primary" disabled={busy} data-testid="club-idea-submit">
          {busy ? 'Wysyłanie…' : '💡 Wyślij pomysł'}
        </button>
      </form>
    </div>
  );
}
